import { z } from 'zod';

export {
  zodSupplierHistoryEntrySchema,
  zodSupplierHistoryResponseSchema,
} from '../validations';

/**
 * Zod schema for the GET /suppliers/details/:deId/history query parameters.
 */
export const zodSupplierHistoryQueryParamsSchema = z.object({
  limit: z.number().int().min(1).nullish(),
  offset: z.number().int().min(0).nullish(),
});
